/** Phones synthesize mouseleave after a tap, and they have no hover to open the label. */
export const pointerHasNoHover = (): boolean => window.matchMedia("(hover: none)").matches;
